<template>
</template>

<script>
import { obrazecService } from '../services/obrazec.service';

export default {
    props:['sezona','pridelovalecid','shema','kontrolaid'],
    created () {

     this.prenesiobrazecip(this.sezona,this.pridelovalecid,this.shema,this.kontrolaid);
 
    },

    methods: {
      
       
         
     
        prenesiobrazecip(sezona,pridelovalecid,shema,kontrolaid){
       
            obrazecService.vrniIpKontrolniList(sezona,pridelovalecid,kontrolaid).then(obrazec=>{
                console.log(obrazec);
            })

        },
        prenesiobrazecipnr(sezona,pridelovalecid,shema,kontrolaid){
            obrazecService.vrniIpKontrolniListNR(sezona,pridelovalecid,kontrolaid).then(obrazec=>{
                console.log(obrazec);
            })

        },

        
    }
};
</script>

